import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const RerunAutosplitModal = memo(function RerunAutosplitModal({
  isOpen,
  onClose,
  onConfirm,
  numSelectedGroups,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  numSelectedGroups: number;
}) {
  const { t } = useTranslation();
  const [autosplitTriggered, setAutosplitTriggered] = useState(false);
  const handleRerunAutosplit = useHandler(async () => {
    setAutosplitTriggered(true);
    await onConfirm();
    setAutosplitTriggered(false);
    onClose();
  });

  const primaryButton: RedoModalButtonProps = {
    text: t("Rerun Autosplit"),
    onClick: handleRerunAutosplit,
    pending: autosplitTriggered,
  };

  const secondaryButton: RedoModalButtonProps = {
    text: t("Cancel"),
    onClick: onClose,
    disabled: autosplitTriggered,
    pending: false,
  };

  return (
    <RedoModal
      buttonPlacement="tight"
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title={t("Rerun autosplit")}
    >
      <Flex dir="column" gap="xl">
        <Text fontSize="md" textColor="primary">
          {t(
            "This will rerun the autosplit logic on your selected {{count}} orders.",
            { count: numSelectedGroups },
          )}
        </Text>
      </Flex>
    </RedoModal>
  );
});
